import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FiltersServiceService } from '../filters-service.service';

@Component({
  selector: 'app-indoor-calendar-bootstrap',
  templateUrl: './indoor-calendar-bootstrap.component.html',
  styleUrls: ['./indoor-calendar-bootstrap.component.scss'],
  providers: []
})
export class IndoorCalendarBootstrapComponent implements OnInit {
  constructor(public filters: FiltersServiceService) {

  }

  ngOnInit() {
  }

}
